import React, { useState, useEffect } from "react";
import {
  useSelector,
  useDispatch
} from "react-redux";
import EditRatingModal from "./components/EditRatingModal.jsx";
import SuccessOverlay from "../../UserComponents/overlays/SuccessOverlay.js";
import { editTeam, updateTeamSetting } from "../../services/team.services.js";
import { UpdateSelectedTeam } from "../../redux/actions/team.actions.js";
// import HeaderBackButton from "../../../components/HeaderBackButton";
import "./settingratings.css";
import UserSidebar from "../../../components/userSiderbar/userSidebar.jsx";

const SettingsRatings = (props) => {
  const dispatch = useDispatch();

  const operatorTeam = useSelector((state) => state.team.selectedTeam);
  const user = useSelector((state) => state.auth.user);

  const [initialFormState, setInitialFormState] = useState(null);
  const [loading, setLoading] = useState(false);
  const [successVisible, setSuccessVisible] = useState(false);
  const [newRating, setNewRating] = useState(null);
  const [addModalVisible, setAddModalVisible] = useState(false);
  const [selectedRatingIndex, setSelectedRatingIndex] = useState(null);

  const toggleSuccessModal = () => {
    setSuccessVisible(true);
    setTimeout(() => {
      setSuccessVisible(false);
    }, 2500);
  };

  useEffect(() => {
    if (operatorTeam?.teamId?.stats_rating) {
      setInitialFormState(operatorTeam.teamId.stats_rating);
    }
  }, [operatorTeam?.teamId?.stats_rating]);

  const handleSave = async () => {
    try {
      setLoading(true);

      // Create a proper immutable update
      const updatedRatings = initialFormState.map((rating, index) => {
        if (index === selectedRatingIndex) {
          // Return new object for the updated item
          return {
            ...rating,
            value: parseInt(newRating, 10) || 0
          };
        }
        return rating; // Return original for other items
      });

      const response = await editTeam(
        {
          teamId: operatorTeam.teamId._id,
          stats_rating: updatedRatings,
        },
        user?.token
      );

      toggleSuccessModal();
      dispatch(UpdateSelectedTeam(operatorTeam?._id));
      setNewRating(null);
      setInitialFormState(updatedRatings);
      setAddModalVisible(false);
    } catch (e) {
      console.log("Error at newRating:", e.response?.data || e.message || e);
    } finally {
      setLoading(false);
    }
  };
  const openEditModal = (index, value) => {
    setSelectedRatingIndex(index);
    setNewRating(value.toString());
    setAddModalVisible(true);
  };

  const handleCloseModal = () => {
    setAddModalVisible(false);
  };

  const handleResetToDefault = async () => {
    if (window.confirm("Are you sure you want to reset the +/- Ratings to default?")) {
      try {
        setLoading(true);
        const settingName = 'stats_rating';
        const teamId = operatorTeam.teamId._id;
        const token = user?.token;
        await updateTeamSetting(
          settingName, teamId, token,
        );
        toggleSuccessModal();
        dispatch(UpdateSelectedTeam(operatorTeam?._id));
        setInitialFormState([]);
      } catch (e) {
        console.log("Error at Reset +/- ratings:", e.response?.data);
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <div className="settings-rating-container">
      <UserSidebar />
      <header className="settings-rating-header">
        {/* <HeaderBackButton /> */}
        <h1 style={{ color: '#1a2a6c', fontSize: '35px' }}>+/- RATINGS</h1>
        <button className="reset-btn" onClick={handleResetToDefault} disabled={loading}>
          Reset to Default
        </button>

      </header>
      <div style={{ display: 'flex', justifyContent: 'end', marginRight: '50px' }}>
        <div className="ratings-list">
          {operatorTeam &&
            operatorTeam.teamId.stats_rating.map((v, i) => (
              <div
                key={i}
                className="rating-item"
                onClick={() => openEditModal(i, v.value)}
              >
                <span className="rating-name">{v.name}</span>
                <span className="rating-value">Rating: {v.value}</span>
              </div>
            ))}
        </div>
      </div>

      {addModalVisible && (
        <EditRatingModal
          // onClose={() => setAddModalVisible(false)}
          visible={addModalVisible}
          newRating={newRating}
          setNewRating={setNewRating}
          handleSave={handleSave}
          onBackdropPress={handleCloseModal}
        />
      )}

      {successVisible && (
        <SuccessOverlay
          onClose={() => setSuccessVisible(false)}
          message="Default Stat rating edited successfully!"
        />
      )}
    </div>
  );
};

export default SettingsRatings;
